import { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Checkbox, ExpandableLink } from '@bwoty-web/styleguide';
import './checkboxFilter.scss';

const CheckboxFilter = ({ selected, onChange, matches, id, options, maxShownOptions, expandLabel, collapseLabel }) => {
  const [expanded, setExpanded] = useState(false);

  const getCheckboxOption = (option) => {
    let optionMatches = -1;
    let optionDisabled = false;

    if (
      matches !== null &&
      typeof matches === 'object' &&
      Object.getOwnPropertyNames(matches).length !== 0
    ) {
      optionMatches = matches[option.id];
      optionDisabled = optionMatches < 1;
    }

    const optionClassNames = classNames('checkbox-filter__option', {
      'checkbox-filter__option--disabled': optionDisabled,
    });

    return (
      <Checkbox
        className={optionClassNames}
        key={`${id}_${option.id}`}
        onChange={() => {
          onChange(option.id);
        }}
        uniqueId={`${id}_${option.id}`}
        checked={selected.includes(option.id)}
        disabled={optionDisabled}
      >
        {optionMatches !== -1
          ? `${option.name} (${optionMatches})`
          : option.name}
      </Checkbox>
    );
  };
  
  let checkboxGroupExpandable = [];
  let checkboxGroup = [];

  if (maxShownOptions > 0) {
    checkboxGroup = options
      .slice(0, maxShownOptions)
      .map(getCheckboxOption);

    checkboxGroupExpandable = options
      .slice(maxShownOptions)
      .map(getCheckboxOption);
  } else {
    checkboxGroup = options.map(getCheckboxOption);
  }

  const className = classNames('checkbox-filter__expandable', {
    'checkbox-filter__expandable--expanded': expanded,
  });
  const toggleExpandableLabel = expanded ? collapseLabel : expandLabel;

  return (
    <div className="checkbox-filter">
      {checkboxGroup}
      {checkboxGroupExpandable.length > 0 && (
        <div>
          <div className={className}>{checkboxGroupExpandable}</div>
          <ExpandableLink
            className="checkbox-filter__toggle-expandable-link"
            onClick={() => setExpanded(!expanded)}
            isOpen={expanded}
          >
            {toggleExpandableLabel}
          </ExpandableLink>
        </div>
      )}
    </div>
  );
};

CheckboxFilter.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func,
  matches: PropTypes.shape({}),
  id: PropTypes.string.isRequired,
  maxShownOptions: PropTypes.number,
  expandLabel: PropTypes.string,
  collapseLabel: PropTypes.string,
};

CheckboxFilter.defaultProps = {
  onChange: () => {},
  matches: {},
  maxShownOptions: -1,
  expandLabel: '',
  collapseLabel: '',
};

export default CheckboxFilter;
